import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/change-password")({
  component: RouteComponent,
});

function RouteComponent() {
  return "logout and request link";
}
